import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Typography,
} from '@growdash/design-system/atoms';
import BlurMap from '@growdash/growintel/assets/images/map-blur.png';
import { SparklesIcon } from 'lucide-react';

export default function LocationCoverageView() {
  return (
    <Card className="mt-6">
      <CardHeader className="flex items-center justify-between">
        <CardTitle>Location and delivery coverage</CardTitle>
        <div className="p-0.5 rounded-full shadow-button h-7">
          <div className="flex items-center justify-center gap-1 h-full bg-gradient-purple-tag rounded-full p-[1px] bg-card text-[#8D73EE] px-2 font-medium text-xs">
            <SparklesIcon size={12} />
            Coming Soon
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <img
          className=" pointer-events-none select-none object-cover"
          src={BlurMap}
          alt="Blurred Map View"
          loading="lazy"
        />

        <Typography className="mt-6" variant="caption">
          Select restaurants to get customized insights about delivery coverage
          and location
        </Typography>
      </CardContent>
    </Card>
  );
}
